import { render } from "./TextPreview.vue?vue&type=template&id=66bc8112&scoped=true"
import script from "./TextPreview.vue?vue&type=script&lang=js"
export * from "./TextPreview.vue?vue&type=script&lang=js"

import "./TextPreview.vue?vue&type=style&index=0&id=66bc8112&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66bc8112"]])

export default __exports__